// hotel_collect,channel_collect

export const PaymentTypes = [
    { value: 'hotel_collect', label: 'Hotel Collect' },
    { value: 'channel_collect', label: 'Channel Collect' },
    { value: '', label: 'Not Set' },
]

export type PaymentType = typeof PaymentTypes[number]['value']